<template lang="html">
  <div class="property">
    <ClickableListItem
      :is_completely_clickable="true"
      padding="8px 4px"
      :has_lines="true"
      :full_line="true"
      :is_first="is_first"
      height="64"
      :foreground_color="getColor(foreground_color)"
      :background_color="getColor(background_color)"
      @emittedClick="$emit('click')"
    >
      <template #descriptor>
        <ProjectStructureElementValue
          :map_value="true"
          :set_material="true"
          :value_is_number="!isNaN(parseFloat(property.value))"
          :is_edit_mode="mapable"
          :foreground_color="foreground_color"
          :background_color="background_color"
          @mapValue="$emit('mapValue', $event)"
        >
          <TText
            class="property-text"
            :text="`${property.name}: ${property.value}`"
            align="left"
            max_lines="1"
            :color="getColor(foreground_color)"
          />
        </ProjectStructureElementValue>
      </template>
      <template #info v-if="editable">
        <TTooltip
          value="Delete property"
          left
        >
          <TIconButton
            icon="sign-close"
            :color="getColor(foreground_color)"
            @clickIcon="edit = false, $emit('delete', $event)"
          />
        </TTooltip>
      </template>
    </ClickableListItem>
  </div>
</template>

<script>
import { TColor } from '@/mixins/TColor.mixin.js';
import ProjectStructureElementValue from '@/components/ProjectStructure/ProjectStructureElementValue.component.vue';
import ClickableListItem from '@/components/WorkPackageWIP/ClickableListItem.component.vue';
import TTooltip from '@/components/Taktify/TTooltip.component.vue';
import TIconButton from '@/components/Taktify/TIconButton.component.vue';

export default {
  props: [
    'property',
    'editable',
    'mapable',
    'is_first',
    'foreground_color',
    'background_color',
  ],

  mixins: [
    TColor,
  ],

  components: {
    ProjectStructureElementValue,
    ClickableListItem,
    TTooltip,
    TIconButton,
  },

  data: function () {
    return {
      edit: false
    }
  }
}
</script>

<style lang="css" scoped>
.property {
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  justify-content: flex-start;
}

.property-text {
  flex-grow: 1;
  pointer-events: none;
}
</style>
